export default __webpack_public_path__ + "static/media/home_logo_text.f48c07eb.png";